// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViCmsS9q{display:flex;flex:1;flex-direction:column;min-height:0}`, "",{"version":3,"sources":["webpack://./src/pages/app/canvas/page.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,MAAA,CACA,qBAAA,CACA,YAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canvasTabHosts": `ViCmsS9q`
};
export default ___CSS_LOADER_EXPORT___;
